import { render, staticRenderFns } from "./WeaponIcon.vue?vue&type=template&id=410ff7f0&scoped=true&"
import script from "./WeaponIcon.vue?vue&type=script&lang=js&"
export * from "./WeaponIcon.vue?vue&type=script&lang=js&"
import style0 from "./WeaponIcon.vue?vue&type=style&index=0&id=410ff7f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410ff7f0",
  null
  
)

export default component.exports